import { useContext, useEffect } from "react";
import GlobalContext from "@context/GlobalContext";

export default function useLoading(isPending) {
  const dispatch = useContext(GlobalContext)[1];

  useEffect(() => {
    handleLoading(isPending);
  }, [isPending]);

  const handleLoading = (status) => {
    dispatch({
      type: "SET_LOADING",
      payload: status,
    });
  };

  return [handleLoading];
}
